import React, { Component } from 'react';
import { Link } from 'react-router-dom';

function retiraMascara(value, type = "texto") {
    var numero = '';
    if (value !== undefined) {
        numero = value.replace('_', '');
        if (type === "link") {
            numero = numero.replace('(', '').replace(')', '').replace('-', '').replace(' ', '');
        }
    }
    return numero;
}


class Cabecalho extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        /*   console.log(this.props.revenda); */

        return (
            <header id="header" className="topbar-dark">
                <div className="topbar">
                    <div className="container">

                    </div>
                </div>

                <div className="menu">
                    <nav id="menu" className="mega-menu">
                        <section className="menu-list-items">
                            <ul className="menu-logo">
                                <li>
                                    <a href="index.html">
                                        <img id="logo_dark_img" src="images/logo.png" alt="logo" />
                                    </a>
                                </li>
                            </ul>

                            <ul className="menu-links">
                                <li><Link to="/">Início</Link></li>
                                <li><Link to="/contato">Contato</Link></li>
                                <li><Link to="/estoque">Estoque</Link></li>
                            </ul>

                            <a className="btn-fale-conosco" href='https://api.whatsapp.com/send?text=Olá,vi um anúncio em seu site e gostaria de saber mais sobre o veículo?&phone=5511913556722' target='_blank'>Fale conosco</a>
                        </section>
                    </nav>
                </div>
                <div className="topbar">
                    <div className="container">

                    </div>
                </div>

            </header>

        )
    }

}

export default Cabecalho;